<template>
  <div id="pie"
       :style="size"
       style="display: flex;align-items:center;flex-direction: column">
    <!-- <p style="color: white;font-size: 22px">周销量</p> -->
    <e-charts :size="size"
              style="margin-bottom: 10px;overflow: hidden"
              :options="options" />
  </div>
</template>

<script>
import ECharts from './ECharts'

export default {
  components: {
    ECharts,
  },
  props: {
    weekTime: {
      // 日期
      type: Object,
      default: () => ({}),
    },
    weekWeight: {
      // 净重
      type: Object,
      default: () => ({}),
    },
  },
  mounted() {},
  data: function () {
    return {
      year: 2000,
      options: {
        tooltip: {
          trigger: 'axis',
        },
        legend: {
          textStyle: {
            color: 'white',
          },
        },
        grid: {
          left: '3%',
          right: '7%',
          bottom: '3%',
          containLabel: true,
        },
        xAxis: {
          name: '日期',
          axisLine: {
            lineStyle: {
              color: 'white',
            },
          },
          axisTick: {
            show: false,
          },
          type: 'category',
          boundaryGap: false,
          data: JSON.parse(JSON.stringify(this.weekTime)),
          /*  axisLabel: {
              formatter: val => {
                let txt = val
                if (val.length > 4) {
                  txt = `${val.substr(0, 3)  }...`
                }
                return txt
              }
            }, */
        },
        yAxis: {
          name: '净重',
          type: 'value',
          axisLine: {
            lineStyle: {
              color: 'white',
            },
          },
          axisTick: {
            // y轴刻度线
            show: false,
          },
          splitLine: {
            show: true, // 网格线
            lineStyle: {
              type: 'dashed',
            },
          },
        },
        series: [
          {
            label: {
              show: true, // 开启显示
              position: 'top', // 在上方显示
              textStyle: {
                // 数值样式
                color: 'white',
                fontSize: 12,
              },
            },
            color: '#ff2e63',
            name: '每日销售量',
            type: 'line',
            stack: 'Totall',
            data: JSON.parse(JSON.stringify(this.weekWeight)),
          },

          /* {       // 若需要双线显示，只需添加该注释代码格式
             color:'blue',
             name: 'Direct',
             type: 'line',
             stack: 'Total',
             data: [320, 332, 301, 334, 390, 330, 320]
           },*/
        ],
      },
      size: {
        width: '100%',
        height: '340px',
      },
    }
  },
}
</script>

<style scoped>
</style>
